/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetSearchResultsQueryVariables = Types.Exact<{
  q: Types.Scalars["String"]["input"];
  filters?: Types.InputMaybe<
    Array<Types.FreestyleSearchFilterInput> | Types.FreestyleSearchFilterInput
  >;
  sort?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  page: Types.Scalars["Int"]["input"];
  limit: Types.Scalars["Int"]["input"];
  autoSearch: Types.Scalars["Boolean"]["input"];
}>;

export type GetSearchResultsQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    id: string;
    search?: {
      __typename?: "FreestyleSearch";
      id: string;
      queryId: string;
      outfitCacheId?: string | null;
      correctedQuery?: string | null;
      shopProductsByPage: {
        __typename?: "ShopProductPageConnection";
        pageCount: number;
        edges: Array<{
          __typename?: "ShopProductPageEdge";
          node: {
            __typename?: "ShopProduct";
            id: string;
            name: string;
            brand: { __typename?: "Brand"; name: string };
            variantBySkuId?: {
              __typename?: "ShopProductVariant";
              id: string;
              sku: string;
              url: string;
              saved: boolean;
              inventory: {
                __typename?: "ShopInventory";
                availability: Types.InventoryAvailability;
              };
              price: { __typename?: "Money"; currency: Types.Currency; value: number };
              priceMarkdown?: {
                __typename?: "PriceMarkdown";
                discountLabel: string;
                fullPrice: { __typename?: "Money"; currency: Types.Currency; value: number };
              } | null;
              promoDiscountOffer?: {
                __typename?: "PromoDiscountOffer";
                displayLabel: { __typename?: "RichText"; formatted: string };
              } | null;
              media: Array<{
                __typename?: "ShopMedia";
                baseUrl: string;
                mediaPath: string;
                altText: string;
              }>;
            } | null;
          };
        }>;
      };
      filters: Array<{
        __typename?: "FreestyleSearchFilter";
        id: string;
        label: string;
        menuDisplayTemplate: Types.FreestyleSearchFilterDisplayTemplate;
        options: Array<
          | {
              __typename?: "FreestyleSearchFilterColorOption";
              hex: string;
              label: string;
              value: string;
            }
          | { __typename?: "FreestyleSearchFilterTextOption"; label: string; value: string }
        >;
      }>;
      sortOptions: Array<{
        __typename?: "FreestyleSearchSortOption";
        isDefault: boolean;
        label: string;
        value: string;
      }>;
      moreCategories?: {
        __typename?: "ShopCategorySetModule";
        id: string;
        title: string;
        categorySet: {
          __typename?: "ShopCategorySet";
          id: string;
          cards: Array<{
            __typename?: "ShopCategoryCard";
            id: string;
            destinationPath: string;
            title?: string | null;
            image?: {
              __typename?: "ShopCategoryImage";
              altText: string;
              baseUrl: string;
              mediaPath: string;
            } | null;
          }>;
        };
        cta?: { __typename?: "ShopContentCta"; destinationPath: string; text: string } | null;
        endCard?: {
          __typename?: "ShopEndCard";
          cta: { __typename?: "ShopContentCta"; destinationPath: string; text: string };
          image: {
            __typename?: "ShopContentImage";
            altText: string;
            baseUrl: string;
            mediaPath: string;
          };
        } | null;
      } | null;
      siteNavigationModule?: {
        __typename?: "FreestyleSearchSiteNavigationModule";
        id: string;
        title: string;
        description: string;
        cta: { __typename?: "ShopContentCta"; text: string; destinationPath: string };
      } | null;
    } | null;
  } | null;
};

export type SearchFragment = {
  __typename?: "FreestyleSearch";
  id: string;
  queryId: string;
  outfitCacheId?: string | null;
  correctedQuery?: string | null;
  shopProductsByPage: {
    __typename?: "ShopProductPageConnection";
    pageCount: number;
    edges: Array<{
      __typename?: "ShopProductPageEdge";
      node: {
        __typename?: "ShopProduct";
        id: string;
        name: string;
        brand: { __typename?: "Brand"; name: string };
        variantBySkuId?: {
          __typename?: "ShopProductVariant";
          id: string;
          sku: string;
          url: string;
          saved: boolean;
          inventory: { __typename?: "ShopInventory"; availability: Types.InventoryAvailability };
          price: { __typename?: "Money"; currency: Types.Currency; value: number };
          priceMarkdown?: {
            __typename?: "PriceMarkdown";
            discountLabel: string;
            fullPrice: { __typename?: "Money"; currency: Types.Currency; value: number };
          } | null;
          promoDiscountOffer?: {
            __typename?: "PromoDiscountOffer";
            displayLabel: { __typename?: "RichText"; formatted: string };
          } | null;
          media: Array<{
            __typename?: "ShopMedia";
            baseUrl: string;
            mediaPath: string;
            altText: string;
          }>;
        } | null;
      };
    }>;
  };
  filters: Array<{
    __typename?: "FreestyleSearchFilter";
    id: string;
    label: string;
    menuDisplayTemplate: Types.FreestyleSearchFilterDisplayTemplate;
    options: Array<
      | {
          __typename?: "FreestyleSearchFilterColorOption";
          hex: string;
          label: string;
          value: string;
        }
      | { __typename?: "FreestyleSearchFilterTextOption"; label: string; value: string }
    >;
  }>;
  sortOptions: Array<{
    __typename?: "FreestyleSearchSortOption";
    isDefault: boolean;
    label: string;
    value: string;
  }>;
  moreCategories?: {
    __typename?: "ShopCategorySetModule";
    id: string;
    title: string;
    categorySet: {
      __typename?: "ShopCategorySet";
      id: string;
      cards: Array<{
        __typename?: "ShopCategoryCard";
        id: string;
        destinationPath: string;
        title?: string | null;
        image?: {
          __typename?: "ShopCategoryImage";
          altText: string;
          baseUrl: string;
          mediaPath: string;
        } | null;
      }>;
    };
    cta?: { __typename?: "ShopContentCta"; destinationPath: string; text: string } | null;
    endCard?: {
      __typename?: "ShopEndCard";
      cta: { __typename?: "ShopContentCta"; destinationPath: string; text: string };
      image: {
        __typename?: "ShopContentImage";
        altText: string;
        baseUrl: string;
        mediaPath: string;
      };
    } | null;
  } | null;
  siteNavigationModule?: {
    __typename?: "FreestyleSearchSiteNavigationModule";
    id: string;
    title: string;
    description: string;
    cta: { __typename?: "ShopContentCta"; text: string; destinationPath: string };
  } | null;
};

export type SearchResultsFragment = {
  __typename?: "ShopProductPageConnection";
  pageCount: number;
  edges: Array<{
    __typename?: "ShopProductPageEdge";
    node: {
      __typename?: "ShopProduct";
      id: string;
      name: string;
      brand: { __typename?: "Brand"; name: string };
      variantBySkuId?: {
        __typename?: "ShopProductVariant";
        id: string;
        sku: string;
        url: string;
        saved: boolean;
        inventory: { __typename?: "ShopInventory"; availability: Types.InventoryAvailability };
        price: { __typename?: "Money"; currency: Types.Currency; value: number };
        priceMarkdown?: {
          __typename?: "PriceMarkdown";
          discountLabel: string;
          fullPrice: { __typename?: "Money"; currency: Types.Currency; value: number };
        } | null;
        promoDiscountOffer?: {
          __typename?: "PromoDiscountOffer";
          displayLabel: { __typename?: "RichText"; formatted: string };
        } | null;
        media: Array<{
          __typename?: "ShopMedia";
          baseUrl: string;
          mediaPath: string;
          altText: string;
        }>;
      } | null;
    };
  }>;
};

export type ShopProductFragment = {
  __typename?: "ShopProduct";
  id: string;
  name: string;
  brand: { __typename?: "Brand"; name: string };
  variantBySkuId?: {
    __typename?: "ShopProductVariant";
    id: string;
    sku: string;
    url: string;
    saved: boolean;
    inventory: { __typename?: "ShopInventory"; availability: Types.InventoryAvailability };
    price: { __typename?: "Money"; currency: Types.Currency; value: number };
    priceMarkdown?: {
      __typename?: "PriceMarkdown";
      discountLabel: string;
      fullPrice: { __typename?: "Money"; currency: Types.Currency; value: number };
    } | null;
    promoDiscountOffer?: {
      __typename?: "PromoDiscountOffer";
      displayLabel: { __typename?: "RichText"; formatted: string };
    } | null;
    media: Array<{ __typename?: "ShopMedia"; baseUrl: string; mediaPath: string; altText: string }>;
  } | null;
};

export type ShopProductVariantFragment = {
  __typename?: "ShopProductVariant";
  id: string;
  sku: string;
  url: string;
  saved: boolean;
  inventory: { __typename?: "ShopInventory"; availability: Types.InventoryAvailability };
  price: { __typename?: "Money"; currency: Types.Currency; value: number };
  priceMarkdown?: {
    __typename?: "PriceMarkdown";
    discountLabel: string;
    fullPrice: { __typename?: "Money"; currency: Types.Currency; value: number };
  } | null;
  promoDiscountOffer?: {
    __typename?: "PromoDiscountOffer";
    displayLabel: { __typename?: "RichText"; formatted: string };
  } | null;
  media: Array<{ __typename?: "ShopMedia"; baseUrl: string; mediaPath: string; altText: string }>;
};

export type ShopProductVariantSavedFragment = { __typename?: "ShopProductVariant"; saved: boolean };

export type FilterFragment = {
  __typename?: "FreestyleSearchFilter";
  id: string;
  label: string;
  menuDisplayTemplate: Types.FreestyleSearchFilterDisplayTemplate;
  options: Array<
    | { __typename?: "FreestyleSearchFilterColorOption"; hex: string; label: string; value: string }
    | { __typename?: "FreestyleSearchFilterTextOption"; label: string; value: string }
  >;
};

export type SortFragment = {
  __typename?: "FreestyleSearchSortOption";
  isDefault: boolean;
  label: string;
  value: string;
};

export type SearchCategoryCardsModuleFragment = {
  __typename?: "ShopCategorySetModule";
  id: string;
  title: string;
  categorySet: {
    __typename?: "ShopCategorySet";
    id: string;
    cards: Array<{
      __typename?: "ShopCategoryCard";
      id: string;
      destinationPath: string;
      title?: string | null;
      image?: {
        __typename?: "ShopCategoryImage";
        altText: string;
        baseUrl: string;
        mediaPath: string;
      } | null;
    }>;
  };
  cta?: { __typename?: "ShopContentCta"; destinationPath: string; text: string } | null;
  endCard?: {
    __typename?: "ShopEndCard";
    cta: { __typename?: "ShopContentCta"; destinationPath: string; text: string };
    image: { __typename?: "ShopContentImage"; altText: string; baseUrl: string; mediaPath: string };
  } | null;
};

export type SearchCategoryCardFragment = {
  __typename?: "ShopCategoryCard";
  id: string;
  destinationPath: string;
  title?: string | null;
  image?: {
    __typename?: "ShopCategoryImage";
    altText: string;
    baseUrl: string;
    mediaPath: string;
  } | null;
};

export type CtaFragment = { __typename?: "ShopContentCta"; destinationPath: string; text: string };

export const ShopProductVariantSavedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariantSaved" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "saved" } }],
      },
    },
  ],
} as unknown as DocumentNode;
export const ShopProductVariantFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inventory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "availability" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceMarkdown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullPrice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "discountLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "promoDiscountOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: { kind: "EnumValue", value: "SHOP" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayLabel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "formatted" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "media" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentType" },
                      value: { kind: "EnumValue", value: "IMAGE" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                { kind: "Field", name: { kind: "Name", value: "altText" } },
              ],
            },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariantSaved" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariantSaved" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "saved" } }],
      },
    },
  ],
} as unknown as DocumentNode;
export const ShopProductFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "variantBySkuId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariant" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariantSaved" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "saved" } }],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inventory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "availability" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceMarkdown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullPrice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "discountLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "promoDiscountOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: { kind: "EnumValue", value: "SHOP" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayLabel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "formatted" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "media" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentType" },
                      value: { kind: "EnumValue", value: "IMAGE" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                { kind: "Field", name: { kind: "Name", value: "altText" } },
              ],
            },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariantSaved" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SearchResultsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchResults" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ShopProductPageConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pageCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProduct" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariantSaved" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "saved" } }],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inventory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "availability" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceMarkdown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullPrice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "discountLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "promoDiscountOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: { kind: "EnumValue", value: "SHOP" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayLabel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "formatted" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "media" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentType" },
                      value: { kind: "EnumValue", value: "IMAGE" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                { kind: "Field", name: { kind: "Name", value: "altText" } },
              ],
            },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariantSaved" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "variantBySkuId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariant" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FilterFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Filter" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FreestyleSearchFilter" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "menuDisplayTemplate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "FreestyleSearchFilterColorOption" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "hex" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SortFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Sort" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FreestyleSearchSortOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isDefault" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SearchCategoryCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchCategoryCard" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopCategoryCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "altText" } },
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CtaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Cta" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopContentCta" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SearchCategoryCardsModuleFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchCategoryCardsModule" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopCategorySetModule" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "categorySet" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cards" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SearchCategoryCard" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Cta" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "endCard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Cta" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                      { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchCategoryCard" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopCategoryCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "altText" } },
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Cta" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopContentCta" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SearchFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Search" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FreestyleSearch" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "queryId" } },
          { kind: "Field", name: { kind: "Name", value: "outfitCacheId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductsByPage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: { kind: "Variable", name: { kind: "Name", value: "page" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "SearchResults" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "filters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Filter" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sortOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Sort" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "moreCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SearchCategoryCardsModule" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "correctedQuery" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "siteNavigationModule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariantSaved" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "saved" } }],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inventory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "availability" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceMarkdown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullPrice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "discountLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "promoDiscountOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: { kind: "EnumValue", value: "SHOP" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayLabel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "formatted" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "media" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentType" },
                      value: { kind: "EnumValue", value: "IMAGE" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                { kind: "Field", name: { kind: "Name", value: "altText" } },
              ],
            },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariantSaved" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "variantBySkuId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariant" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchCategoryCard" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopCategoryCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "altText" } },
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Cta" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopContentCta" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchResults" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ShopProductPageConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pageCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProduct" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Filter" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FreestyleSearchFilter" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "menuDisplayTemplate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "FreestyleSearchFilterColorOption" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "hex" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Sort" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FreestyleSearchSortOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isDefault" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchCategoryCardsModule" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopCategorySetModule" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "categorySet" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cards" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SearchCategoryCard" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Cta" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "endCard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Cta" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                      { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetSearchResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSearchResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "q" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "FreestyleSearchFilterInput" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "limit" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "autoSearch" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shopContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "search" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "input" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "query" },
                            value: { kind: "Variable", name: { kind: "Name", value: "q" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "filters" },
                            value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "sort" },
                            value: { kind: "Variable", name: { kind: "Name", value: "sort" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "autoSearch" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "autoSearch" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "Search" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariantSaved" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "saved" } }],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProductVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inventory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "availability" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceMarkdown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullPrice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "discountLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "promoDiscountOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: { kind: "EnumValue", value: "SHOP" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayLabel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "formatted" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "media" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentType" },
                      value: { kind: "EnumValue", value: "IMAGE" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                { kind: "Field", name: { kind: "Name", value: "altText" } },
              ],
            },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariantSaved" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShopProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "variantBySkuId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProductVariant" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchResults" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ShopProductPageConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pageCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ShopProduct" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Filter" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FreestyleSearchFilter" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "menuDisplayTemplate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "FreestyleSearchFilterColorOption" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "hex" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Sort" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FreestyleSearchSortOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isDefault" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchCategoryCard" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopCategoryCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "altText" } },
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Cta" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopContentCta" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchCategoryCardsModule" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopCategorySetModule" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "categorySet" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cards" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SearchCategoryCard" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Cta" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "endCard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Cta" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                      { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Search" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FreestyleSearch" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "queryId" } },
          { kind: "Field", name: { kind: "Name", value: "outfitCacheId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductsByPage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: { kind: "Variable", name: { kind: "Name", value: "page" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "SearchResults" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "filters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Filter" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sortOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Sort" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "moreCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SearchCategoryCardsModule" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "correctedQuery" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "siteNavigationModule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "destinationPath" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      autoSearch: // value for 'autoSearch'
 *   },
 * });
 */
export function useGetSearchResultsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables> &
    ({ variables: GetSearchResultsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(
    GetSearchResultsDocument,
    options,
  );
}
export function useGetSearchResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(
    GetSearchResultsDocument,
    options,
  );
}
// @ts-ignore
export function useGetSearchResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSearchResultsQuery, GetSearchResultsQueryVariables>;
export function useGetSearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetSearchResultsQuery | undefined, GetSearchResultsQueryVariables>;
export function useGetSearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(
    GetSearchResultsDocument,
    options,
  );
}
export type GetSearchResultsQueryHookResult = ReturnType<typeof useGetSearchResultsQuery>;
export type GetSearchResultsLazyQueryHookResult = ReturnType<typeof useGetSearchResultsLazyQuery>;
export type GetSearchResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetSearchResultsSuspenseQuery
>;
export type GetSearchResultsQueryResult = Apollo.QueryResult<
  GetSearchResultsQuery,
  GetSearchResultsQueryVariables
>;
